import { Injectable } from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {mainStoreSelectors} from '../stores/main-store/main-store.selectors';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  /**
   * get user from store
   */
  get user$() {
    return this.store.select(mainStoreSelectors.user);
  }

  get singing$() {
    return this.store.select(mainStoreSelectors.signing);
  }

  /**
   * page can be activated when user info is in store
   */
  canActivate(): Observable<boolean | UrlTree> {
    return combineLatest([
      this.singing$,
      this.user$,
    ]).pipe(map(res => {
      if (res && !res[0]) {
        const can = !!res[1];

        if (!can) {
          this.router.navigate(['/home/login']);
        }

        return can;
      }
    }));
  }
}
